import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IPOMessage, IPOTag } from '@hylaa-npm/ipod';

import AddUserPop from '@/components/AddUserPop';
import { accountAddTag, changeStaffBasic, delTmpAccount, addOfficial } from '@/apis/account';
import { ITmpAccount, ITmpAccountTeamMember } from '../../member';

import { CustomModal } from '@/styles/components/CustomModal';
import { StandardWrap, TipsWrap } from './style';

interface Props {
	memberInfo: ITmpAccount;
	/**
	 * 弹出窗的层级
	 */
	zIndex?: number;
	/**
	 * 取消按钮被点击
	 */
	handleCancel?: () => void;
	handleOk?: (id: string) => void;
	teamTag?: IPOTag.ITag[];
	majorTag?: IPOTag.ITag[];
}
const CreateMember: FC<Props> = ({
	memberInfo,
	zIndex,
	handleCancel,
	handleOk,
	teamTag,
	majorTag,
}) => {
	const userRef = useRef();
	const { t } = useTranslation();
	const [tags, setTags] = useState<IPOTag.ITag[]>([]);
	const [tmpTags, setTmpTags] = useState<IPOTag.ITag[]>([]);
	const [teamAllTags, setTeamTags] = useState<IPOTag.ITag[]>([]);
	const [majorAllTags, setMajorTags] = useState<IPOTag.ITag[]>([]);
	const [projectData, setProjectData] = useState<
		{
			name: string;
			id: string;
			team: { name: string; id: string }[];
		}[]
	>();
	const [clintData, setClintData] = useState<
		{
			name: string;
			id: string;
		}[]
	>();
	useEffect(() => {
		if (memberInfo) {
			if (memberInfo.teamMembers) {
				getViewData(memberInfo.teamMembers);
			}
		}
	}, [memberInfo]);
	// 需要解构出标签，去重，还需要判端标准标签是否被删除了
	const getViewData = (teamMembers: ITmpAccountTeamMember[]) => {
		let tagList: IPOTag.ITag[] = [];
		let tagIds: string[] = [];
		let teams: {
			desc: string;
			id: string;
			name: string;
			projectId: string;
			type: 'MANAGER';
			project: { client: { id: string; name: string }; id: string; name: string };
		}[] = [];
		teamMembers.forEach((teamMember) => {
			if (teamMember.tags) {
				teamMember.tags.forEach((v) => {
					if (!tagIds.includes(v.id)) {
						tagList.push(v);
						tagIds.push(v.id);
					}
				});
			}
			if (teamMember.team) {
				teams.push(teamMember.team);
			}
		});
		let tagTmpList: IPOTag.ITag[] = [];
		teamMembers.filter((teamMember) => {
			if (teamMember.tmpTags) {
				teamMember.tmpTags.forEach((v) => {
					tagTmpList.push(v);
				});
			}
		});
		let newTags: IPOTag.ITag[] = tagList.map((item) => {
			return {
				desc: item.desc,
				icon: item.icon,
				id: item.id,
				name: item.name,
				type: item.type,
			};
		});
		setTags(newTags);
		let newTmpTags: IPOTag.ITag[] = tagTmpList.map((item) => {
			return {
				desc: item.desc,
				icon: item.icon,
				id: item.id,
				name: item.name,
				type: item.type,
			};
		});
		setTmpTags(newTmpTags);
		let allTags = [...newTags, ...newTmpTags];
		let newTeams = allTags.filter((item) => item.type === 2);
		setTeamTags(newTeams);
		let newMajors = allTags.filter((item) => item.type === 1);
		setMajorTags(newMajors);
		// 解构出 提示信息来
		let clintList: { name: string; id: string }[] = [];
		let clintIds: string[] = [];
		let tipsdata: { name: string; id: string; team: { name: string; id: string }[] }[] = [];
		teams.forEach((item) => {
			let prodata = {
				name: item.project.name,
				id: item.project.id,
				team: [{ name: item.name, id: item.id }],
			};
			tipsdata.push(prodata);
			if (!clintIds.includes(item.project.client.id)) {
				clintList.push({
					name: item.project.client.name,
					id: item.project.client.id,
				});
				clintIds.push(item.project.client.id);
			}
		});
		// clintList  需要去重
		setClintData(clintList);
		setProjectData(tipsdata);
	};

	const onOk = async () => {
		let userInfoRuest = ((userRef.current as unknown) as {
			handleUpdateUser: () => {
				name: string;
				name2: string;
				email: string;
				avatar: string;
				major: string[];
				team: string[];
			};
		}).handleUpdateUser();
		if (userInfoRuest) {
			addOfficial(memberInfo.accountId).then((res) => {
				if (res.addState === 2) {
					// 修改信息
					let basic = {
						name: userInfoRuest.name,
						name2: userInfoRuest.name2,
						email: userInfoRuest.email,
						avatar: userInfoRuest.avatar,
						name1: userInfoRuest.name,
					};
					changeStaffBasic(res.accountId, basic).then((res) => {
						IPOMessage.success(t('common.editSucces'));
					});
					// 删除  禁用的成员
					delTmpAccount(memberInfo.id).then((res) => {});
					// 添加标签
					userInfoRuest.major.forEach((tag) => {
						accountAddTag(res.accountId, tag).then((res) => {});
					});
					userInfoRuest.team.forEach((tag) => {
						accountAddTag(res.accountId, tag).then((res) => {});
					});
					handleOk && handleOk(memberInfo.id);
				}
			});
		}
	};
	/** 获取头部标题模板 */
	const getTitle = () => {
		return (
			<StandardWrap>
				<div className="title">{t('standard.addMember')}</div>
			</StandardWrap>
		);
	};
	return (
		<CustomModal
			maskClosable={false}
			getContainer={false}
			isShowPadding={true}
			visible={true}
			title={getTitle()}
			okText={t('common.confirm')}
			cancelText={t('common.cancel')}
			onOk={onOk}
			onCancel={handleCancel}>
			<AddUserPop
				isPop={false}
				userRef={userRef}
				userInfo={{ ...memberInfo, tags: tags, tmpTags: tmpTags }}
				teamTag={teamTag || []}
				majorTag={majorTag || []}
			/>
			<TipsWrap>
				<div>{t('personnel.tips')}</div>
				<div className="tips-item">
					<span>{t('personnel.name')}：</span>
					<span>
						{memberInfo.name2}({memberInfo.name})
					</span>
				</div>
				<div className="tips-item">
					<span>{t('.phone')}：</span>
					<span>{memberInfo.mobile}</span>
				</div>
				<div className="tips-item">
					<span>{t('project.splitServer')}：</span>
					<span>
						{clintData &&
							clintData.map((item, index) => {
								return (
									<span>
										{item.name}
										{index !== clintData.length - 1 ? '、' : ''}
									</span>
								);
							})}
					</span>
				</div>
				<div className="tips-item">
					<span>{t('project.project')}：</span>
					<span>
						{projectData &&
							projectData.map((item, projectLen) => {
								return (
									<span key={item.id}>
										{item.name}
										<span>
											（
											{item.team.map((v, index) => {
												return (
													<span key={v.id}>
														{v.name}
														{index !== item.team.length - 1 ? '、' : ''}
													</span>
												);
											})}
											）
										</span>
										{projectLen !== projectData.length - 1 ? '、' : ''}
									</span>
								);
							})}
					</span>
				</div>
				<div className="tips-item">
					<span>{t('tag.professionalLabel')}：</span>
					<span>
						{majorAllTags.map((item, index) => {
							return (
								<span>
									{item.name} {index !== majorAllTags.length - 1 ? '、' : ''}
								</span>
							);
						})}
					</span>
				</div>
				<div className="tips-item">
					<span>{t('tag.teamLabel')}：</span>
					<span>
						{teamAllTags.map((item, index) => {
							return (
								<span>
									{item.name} {index !== teamAllTags.length - 1 ? '、' : ''}
								</span>
							);
						})}
					</span>
				</div>
			</TipsWrap>
		</CustomModal>
	);
};
export default CreateMember;
